import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client/react';
import { cloneDeep } from 'lodash';
import { ResourceData } from 'framework/crud';
import { GET_PROJECTS_DASHBOARD } from 'domain/shared/newProject/graphql/projectQueries';
import { StaffingDataType } from 'domain/shared/staffing';
import { followUpValidation } from 'domain/shared/employee';

const useStaffingDashboardService = () => {
  const [getProjects] = useLazyQuery<{ baseProjects: StaffingDataType[] }>(GET_PROJECTS_DASHBOARD, {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  const search = useCallback(
    async (request: ResourceData) => {
      const searchParams = cloneDeep(request);

      let searchString = '';
      if (searchParams.filter?.['specification:search']?.eq) {
        searchString = searchParams.filter['specification:search'].eq;
      }

      const createSearchString = (searchTerm: string): string => {
        const filterObject: any = {
          filter: {},
        };

        filterObject.filter.isArchived = { ne_or_null: true };

        if (searchTerm && searchTerm.trim()) {
          filterObject.filter.name = { ct: searchTerm.trim() };
        }

        return JSON.stringify(filterObject);
      };

      try {
        const { data } = await getProjects({
          variables: { searchString: createSearchString(searchString) },
        });

        const projects = data?.baseProjects || [];

        return {
          result: projects,
          totalPages: 1,
          totalElements: projects.length,
        };
      } catch (error) {
        return {
          result: [],
          totalPages: 1,
          totalElements: 0,
        };
      }
    },
    [getProjects],
  );

  const followupValidation = followUpValidation();
  const getFollowUpValidation = () => Promise.resolve(followupValidation);

  return {
    search,
    getFollowUpValidation,
  };
};

export default useStaffingDashboardService;
